import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import common_el from "./translations/el.json";
import common_en from "./translations/en.json";

const normalizeLanguage = lang => {
    const normalized = String(lang || "").toLowerCase();
    if (normalized === "gr" || normalized === "el") return "el";
    if (normalized === "en") return "en";
    return null;
};

export const getInitialLanguage = () => {
    let queryLang = null;

    try {
        const params = new URLSearchParams(window.location.search);
        queryLang = normalizeLanguage(params.get("lang"));
    } catch (e) {
        queryLang = null;
    }

    if (queryLang) {
        window.localStorage.setItem("lang", queryLang);
        return queryLang;
    }

    return normalizeLanguage(window.localStorage.getItem("lang")) || "el";
};

i18n.use(LanguageDetector).init({
    resources: {
        el: {
            common: common_el
        },
        en: {
            common: common_en
        }
    },
    lng: getInitialLanguage(),
    fallbackLng: "el",
    debug: false,
    ns: ["common"],
    defaultNS: "common",
    keySeparator: '.',
    objectNotation: true,
    interpolation: {
        formatSeparator: ","
    },
    react: {
        useSuspense: true
    }
});

export default i18n;
